export default "__VITE_ASSET__CPIRnGfq__"